import React, { createContext, useContext, useEffect, useState } from "react";
import t from "../service/translate.service";
import { storageKeys } from "../const/storageKeys";

const fontStyleProperties = [
  {
    label: "--font-size",
    value: 14,
    unit: "px",
  },
  {
    label: "--font-size-title-primary",
    value: 45,
    unit: "px",
  },
  {
    label: "--font-size-12",
    value: 12,
    unit: "px",
  },
  {
    label: "--font-size-18",
    value: 18,
    unit: "px",
  },
  {
    label: "--font-size-13",
    value: 13,
    unit: "px",
  },
  {
    label: "--font-size-24",
    value: 24,
    unit: "px",
  },
  {
    label: "--font-size-16",
    value: 16,
    unit: "px",
  },
  {
    label: "--font-size-40",
    value: 40,
    unit: "px",
  },
  {
    label: "--font-size-26",
    value: 26,
    unit: "px",
  },
  {
    label: "--font-size-11",
    value: 11,
    unit: "px",
  },
  {
    label: "--font-size-10",
    value: 10,
    unit: "px",
  },
  {
    label: "--font-size-28",
    value: 28,
    unit: "px",
  },
  {
    label: "--font-size-25",
    value: 25,
    unit: "px",
  },
  {
    label: "--font-size-20",
    value: 20,
    unit: "px",
  },
  {
    label: "--font-size-15",
    value: 15,
    unit: "px",
  },
  {
    label: "--font-size-1rem",
    value: 1,
    unit: "rem",
  },
  {
    label: "--font-size-46",
    value: 46,
    unit: "px",
  },
  {
    label: "--font-size-19",
    value: 19,
    unit: "px",
  },
  {
    label: "--font-size-23",
    value: 23,
    unit: "px",
  },
  {
    label: "--font-size-55",
    value: 55,
    unit: "px",
  },
  {
    label: "--font-size-22",
    value: 22,
    unit: "px",
  },
  {
    label: "--font-size-30",
    value: 30,
    unit: "px",
  },
  {
    label: "--font-size-75",
    value: 75,
    unit: "rem",
  },
  {
    label: "--font-size-100",
    value: 100,
    unit: "px",
  },
];

export const magnifiers = [
  {
    label: t.NORMAL,
    value: 1,
  },
  {
    label: t.LARGER,
    value: 1.125,
  },
  {
    label: t.LARGE,
    value: 1.25,
  },
];

export const ThemeContext = createContext({
  magnifiers,
  activeMagnifier: magnifiers[0],
  setActiveMagnifier: (value) => {},
  magnifyText: (number) => {},
});

export const ThemeProvider = ({ children }) => {
  const savedTheme = localStorage.getItem(storageKeys.theme);
  const defaultMagnifierValue = !!savedTheme
    ? JSON.parse(savedTheme).magnifier
    : magnifiers[0];
  const [activeMagnifier, setActiveMagnifier] = useState(defaultMagnifierValue);
  const magnifyText = (number) => number * activeMagnifier.value;

  useEffect(() => {
    fontStyleProperties.forEach(({ label, value, unit }) =>
      document.documentElement.style.setProperty(
        label,
        `${magnifyText(value)}${unit}`
      )
    );
  }, [activeMagnifier]);

  const updateMagnifier = (magnifier) => {
    setActiveMagnifier(magnifier);
    localStorage.setItem(storageKeys.theme, JSON.stringify({ magnifier }));
  };

  return (
    <ThemeContext.Provider
      value={{
        magnifiers,
        activeMagnifier,
        setActiveMagnifier: updateMagnifier,
        magnifyText,
      }}
    >
      {children}
    </ThemeContext.Provider>
  );
};

export const useTheme = () => {
  const context = useContext(ThemeContext);
  if (!context) {
    throw new Error("useTheme must be used within a ThemeProvider");
  }
  return context;
};
